import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

// Legacy .js file: explicit-module-boundary-types expects typed props and return on exports.

const RuleStatusToggle = ({ onChange, type }) => {
	const { t } = useTranslation();
	const statusSelectorClassname =
		type === "blocked" ? "RuleStatusToggle_toggleSelector--blocked" : "RuleStatusToggle_toggleSelector--allowed";
	const blockedTextClassname = type === "blocked" ? "RuleStatusToggle_statusText--blocked" : "RuleStatusToggle_statusText";
	const allowedTextClassname = type === "allowed" ? "RuleStatusToggle_statusText--allowed" : "RuleStatusToggle_statusText";

	const handleChange = (newType) => {
		onChange(newType);
	};

	return (
		<div className="RuleStatusToggle">
			<div className={blockedTextClassname} onClick={() => handleChange("blocked")}>
				{t("policyDrawer.ruleStatusBlocked")}
			</div>
			<div className={allowedTextClassname} onClick={() => handleChange("allowed")}>
				{t("policyDrawer.ruleStatusAllowed")}
			</div>
			<div className={statusSelectorClassname} />
		</div>
	);
};

export default RuleStatusToggle;

RuleStatusToggle.propTypes = {
	onChange: PropTypes.func.isRequired,
	type: PropTypes.oneOf(["blocked", "allowed"]).isRequired,
};
